let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kiYQv")).then(() => parcelRequire('5qwjz'));